import { SVGProps } from 'react';

const SvgVideo = (props: SVGProps<SVGSVGElement>) => (
  <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7.33398 20.1665H29.334C32.791 20.1665 34.5194 20.1665 35.5934 21.2404C36.6673 22.3144 36.6673 24.0429 36.6673 27.4998V29.3332C36.6673 34.5186 36.6673 37.1113 35.0564 38.7223C33.4455 40.3332 30.8528 40.3332 25.6673 40.3332H18.334C13.1485 40.3332 10.5558 40.3332 8.9449 38.7223C7.33398 37.1113 7.33398 34.5186 7.33398 29.3332V20.1665Z"
      stroke="#2196F3"
      strokeWidth="2.5"
    />
    <path
      d="M7.33642 20.1664C6.44946 16.8562 6.00599 15.2011 6.38741 13.7776C6.63729 12.8451 7.12824 11.9947 7.81092 11.312C8.853 10.27 10.5081 9.82649 13.8182 8.93954L26.657 5.4994C27.8913 5.16868 28.5084 5.00332 29.0489 4.96789C31.2687 4.8224 33.3576 6.0284 34.3414 8.02353C34.581 8.50937 34.7464 9.1265 35.0771 10.3608C35.1874 10.7722 35.2425 10.9779 35.2543 11.1581C35.3028 11.898 34.9008 12.5943 34.2357 12.9222C34.0738 13.0021 33.8681 13.0572 33.4567 13.1675L7.33642 20.1664Z"
      stroke="#2196F3"
      strokeWidth="2.5"
    />
    <path d="M26.9499 5.39621L25.7807 15.1995" stroke="#2196F3" strokeWidth="2.5" strokeLinecap="round" />
    <path d="M15.4402 8.47531L14.2709 18.2786" stroke="#2196F3" strokeWidth="2.5" strokeLinecap="round" />
    <path
      d="M25.666 30.2502C25.666 29.4761 24.9378 28.954 23.4814 27.9099C22.0051 26.8515 21.2669 26.3223 20.7165 26.7108C20.166 27.0994 20.166 28.1496 20.166 30.2502C20.166 32.3507 20.166 33.4009 20.7165 33.7895C21.2669 34.178 22.0051 33.6489 23.4814 32.5905C24.9378 31.5463 25.666 31.0243 25.666 30.2502Z"
      stroke="#2196F3"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </svg>
);
export default SvgVideo;
